var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[(!_vm.fakeState)?_c('FloatWarning',{attrs:{"deviceStates":_vm.deviceStates}}):_vm._e(),_vm._v(" "),_c('TabPages')],1)}
var staticRenderFns = []

export { render, staticRenderFns }